import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-800 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-bold text-background-50">
                itaobuy<span className="text-accent-300">sheet</span>
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">
              Il punto di riferimento italiano per trovare, organizzare e comprendere Itaobuy Spreadsheet. Guide, categorie e link aggiornati.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-background-50/40 mb-4 font-label">Link Rapidi</h4>
            <div className="flex flex-col gap-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                Kaspreadsheet.com
              </a>
              <Link to="/articolo/itaobuy-spreadsheet-guida-completa" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                Guida Completa
              </Link>
              <a href="#categorie" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                Categorie
              </a>
              <a href="#guida" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                Cos'è Itaobuy Sheet
              </a>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-background-50/40 mb-4 font-label">Legale</h4>
            <div className="flex flex-col gap-3">
              <Link to="/privacy" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                Privacy Policy
              </Link>
              <Link to="/cookie" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                Cookie Policy
              </Link>
              <Link to="/disclaimer" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                Disclaimer
              </Link>
              <Link to="/termini" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                Termini e Condizioni
              </Link>
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-background-50/40 mb-4 font-label">Seguici</h4>
            <div className="flex items-center gap-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors" aria-label="Twitter">
                <i className="ri-twitter-x-line text-background-50/70"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors" aria-label="Pinterest">
                <i className="ri-pinterest-line text-background-50/70"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors" aria-label="Reddit">
                <i className="ri-reddit-line text-background-50/70"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Brand strip */}
      <div className="border-t border-background-50/10 py-6">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-50/40">
              © {new Date().getFullYear()} itaobuyspread.lol — Questo sito offre informazioni educative relative a Itaobuy Spreadsheet. Non siamo il sito ufficiale e non vendiamo direttamente prodotti.
            </p>
            <p className="font-heading text-2xl font-bold text-background-50/15 tracking-wider">
              ITAOBUY
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}